/** @format */

import { TTravel } from "../declarations/maps/travels";
import { TStore } from "../declarations/store";

export const selectorTravelList = (store: TStore): TTravel[] => store.travels.travelList || [];

export const selectorTravel = (store: TStore, id: string): TTravel | undefined =>
  store.travels.travelList?.find(travel => travel.id === id) || undefined;
